module.exports = new __parcel__URL__("periscope-page-with-activity.tpl.3036c4fc.svg").toString();